import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';

/** Recipe enrichment data from TheMealDB */
export interface RecipeData {
  themealdbId: string;
  name: string;
  category?: string;
  cuisine?: string;
  instructions?: string;
  thumbnailUrl?: string;
  tags: string[];
  youtubeUrl?: string;
  sourceUrl?: string;
  ingredients?: { ingredient: string; measure: string }[];
}

export type Recipe = WithLegacy<{
  name: string | null;
  summary: string | null;
  cuisine: string | null;
  difficulty: string | null;
  cookTimeMinutes: number | null;
  servings: number | null;
  ingredientCount: number | null;
  stepCount: number | null;
  category: string | null;
  categoryEmoji: string | null;
  servingsSource: string | null;
  sourceThumbnailUrl: string | null;
  ingredients: unknown[] | null;
  steps: unknown[] | null;
  sentiment: number | null;
  quote: string | null;
  timestamp: number | null;
  intent: string | null;
  externalId: string | null;
  externalSource: string | null;
  enrichedData: RecipeData | null;
  createdAt: string | null;
  updatedAt: string | null;
  subRecipes: unknown[] | null;
  contentSource: import('./content-source.ts').ContentSource | null;
  item: import('./item.ts').Item | null;
  parentRecipe: Recipe | null;
  [Type]: 'recipes';
}>;

export const RecipeSchema = withDefaults({
  type: 'recipes',
  fields: [
    { name: 'name', kind: 'attribute', type: 'string' },
    { name: 'summary', kind: 'attribute', type: 'string' },
    { name: 'cuisine', kind: 'attribute', type: 'string' },
    { name: 'difficulty', kind: 'attribute', type: 'string' },
    { name: 'cookTimeMinutes', kind: 'attribute', type: 'number' },
    { name: 'servings', kind: 'attribute', type: 'number' },
    { name: 'ingredientCount', kind: 'attribute', type: 'number' },
    { name: 'stepCount', kind: 'attribute', type: 'number' },
    { name: 'category', kind: 'attribute', type: 'string' },
    { name: 'categoryEmoji', kind: 'attribute', type: 'string' },
    { name: 'servingsSource', kind: 'attribute', type: 'string' },
    { name: 'sourceThumbnailUrl', kind: 'attribute', type: 'string' },
    { name: 'ingredients', kind: 'attribute', type: 'object' },
    { name: 'steps', kind: 'attribute', type: 'object' },
    { name: 'sentiment', kind: 'attribute', type: 'number' },
    { name: 'quote', kind: 'attribute', type: 'string' },
    { name: 'timestamp', kind: 'attribute', type: 'number' },
    { name: 'intent', kind: 'attribute', type: 'string' },
    { name: 'externalId', kind: 'attribute', type: 'string' },
    { name: 'externalSource', kind: 'attribute', type: 'string' },
    { name: 'enrichedData', kind: 'attribute', type: 'object' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
    { name: 'updatedAt', kind: 'attribute', type: 'string' },
    { name: 'subRecipes', kind: 'attribute', type: 'object' },
    {
      name: 'contentSource',
      kind: 'belongsTo',
      type: 'content-sources',
      options: { async: false, inverse: null },
    },
    {
      name: 'item',
      kind: 'belongsTo',
      type: 'items',
      options: { async: true, inverse: null },
    },
    {
      name: 'parentRecipe',
      kind: 'belongsTo',
      type: 'recipes',
      options: { async: true, inverse: null },
    },
  ],
});
